import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/app/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../fonts/Poppins-400.ttf\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../fonts/Poppins-600.ttf\",\"weight\":\"600\",\"style\":\"normal\"},{\"path\":\"../fonts/Poppins-700.ttf\",\"weight\":\"700\",\"style\":\"normal\"}],\"display\":\"swap\",\"preload\":true}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsent"] */ "/app/src/components/new/CookieConsent/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SetUserLocationCookie"] */ "/app/src/components/nivaran/main/utils/setUserLocationCookie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/index.tsx");
